import { Link } from 'react-router-dom';
import { hotRecommendations } from '@/mocks/siteData';

export default function HotRecommend() {
  return (
    <section className="w-full max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8 py-16" aria-labelledby="hot-title">
      <div className="flex items-end justify-between mb-10">
        <div>
          <h2 id="hot-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-2">本周最受欢迎的亚洲视频内容</p>
        </div>
        <Link
          to="/category/japan-korea"
          className="whitespace-nowrap hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {hotRecommendations.slice(0, 6).map((item) => (
          <Link
            key={item.id}
            to={`/article/${item.id}`}
            className="group bg-white rounded-xl border border-background-200 overflow-hidden hover:border-background-300 transition-all duration-300 cursor-pointer flex flex-col"
          >
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src={item.imageUrl}
                alt={item.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 flex-1 flex flex-col">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2.5 py-0.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium">
                  {item.category}
                </span>
                <span className="text-xs text-foreground-400">{item.date}</span>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                {item.excerpt}
              </p>
              <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-100">
                <span className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i> {(item.views / 10000).toFixed(1)}万
                </span>
                <div className="flex gap-1.5">
                  {item.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="px-2 py-0.5 rounded-md bg-background-100 text-foreground-500 text-xs">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}